// NotFound.js — Wave 1 adoption of the shared primitives (components/ui).
//
// The old page used an emoji + hard-coded colors + inline styles; it now uses
// the shared EmptyState + Button primitives so every "no content" surface
// (404, empty inbox, no results) looks and behaves identically.
// Public page — no auth rules are touched.

import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, EmptyState } from "../components/ui";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <EmptyState
      title="404 — Page not found"
      hint="The page you’re looking for does not exist. Contact ADMIN +25417648004."
      action={
        <Button variant="primary" onClick={() => navigate("/")}>
          Back to home
        </Button>
      }
    />
  );
};

export default NotFound;
